import Repository from './repository';

const resource = '/auth';
export default {
	impersonationLogin(payload) {
		return Repository.postWithAuth(
			`${resource}/impersonation/login`,
			payload,
			{},
			{ noCache: true }
		);
	},
	refreshToken(payload) {
		return Repository.postWithAuth(
			`${resource}/refreshtoken`,
			payload,
			{},
			{ noCache: true }
		);
	},
	resetImpersonation(payload) {
		return Repository.postWithAuth(
			`${resource}/impersonation/reset`,
			payload,
			{},
			{ noCache: true }
		);
	},
};
